import { combineReducers } from "redux";
import addressesReducer from "./addresses/multiAddresses";
import addressReducer from "./addresses/selectedaddress";
import selectedAccountReducer from "./addresses/selectedAccount";
import balanceReducer from "./balance";
import AllSenderBalanceReducer from "./allSenderBalance";
import ModeStatusReducer from "./addresses/modeStatus";
import TimeZoneReducer from "./addresses/timezone";
import SocketConnection from "./addresses/SocketConnection";
import alertReducer from "./alertReducer";
import walletReducer from "./walletReducer";
import NetworkReducer from "./networkReducer";
import toastReducer from "./toastReducer";

const allreducers = combineReducers({
  MultiAddresses: addressesReducer,
  getBalance: balanceReducer,
  getSelectedAddress: addressReducer,
  SelectedAccount: selectedAccountReducer,
  getAllSenderBalance: AllSenderBalanceReducer,
  modeStatus: ModeStatusReducer,
  timezone: TimeZoneReducer,
  getSocketConnection: SocketConnection,
  alert: alertReducer,
  wallet: walletReducer,
  network: NetworkReducer,
  toast: toastReducer,
});

export default allreducers;
